import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationHead } from "@/components/site/LocationPage";
import { LOCATION_MAP } from "@/components/site/locations";

const SLUG = "elektriker-koebenhavn";
const DATA = LOCATION_MAP[SLUG];

export const Route = createFileRoute("/elektriker-koebenhavn")({
  head: () => locationHead(DATA.city, SLUG),
  component: () => <LocationPage data={DATA} />,
});
